import { Expression } from "../../Expressions/Expression";
import { Nullable, PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { Dialog, DialogPropertyValues, IDialog } from "./Dialog";
import { NAMESPACE } from "./_Namespace";

export type ParameterDialogPropertyValues =
    DialogPropertyValues
    & {
    };

export type ParameterDialogProperties = {
    [name in keyof ParameterDialogPropertyValues]: Property<ParameterDialogPropertyValues[name]>
};

export interface IParameterDialog extends IDialog, ParameterDialogProperties
{
}

export abstract class ParameterDialog extends Dialog implements IParameterDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ParameterDialog";
    public static override className = "ParameterDialog";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ParameterDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                title: "Filter",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ParameterDialogPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-parameter-dialog");
    }

    // #endregion

    // #region Public Methods

    public createExpression(): Nullable<Expression>
    {
        return null;
    }

    // #endregion

    // #region Overrides

    public override async closeAsync()
    {
        this.promiseData = this.createExpression();

        await super.closeAsync();
    }

    // #endregion

    // #endregion
}

